// StreakTabs.jsx

import React, {useRef} from "react";

const TABS = [
    // ── Leaderboard ─────────────────────────────────────────
    { id: "contest",        label: "Contest",       icon: "🚀", group: "leaderboard"},
    { id: "leaderboard",    label: "Leaderboard",   icon: "🏆", group: "leaderboard" },
    { id: "winners",        label: "Winners",       icon: "🎁", group: "leaderboard" },    
    // ── User tabs ────────────────────────────────────
    { id: "summary",       label: "Summary",       icon: "⚡", group: "user"  },
    { id: "new",           label: "New Streaks",   icon: "✚", group: "user"  },
    { id: "ledger",        label: "My Ledger",     icon: "📒", group: "user" },
    { id: "claimform",     label: "Claim Form",    icon: "🧾", group: "user"     },    
    { id: "claims",        label: "Claims History",     icon: "🧾", group: "user"     },
    { id: "redeemrequest",      label: "Redeem Request",    icon: "🎁", group: "user"     },
    { id: "redeemedlist",      label: "Redeemed",    icon: "🎁", group: "user"     },
    // ── Merchant tabs ─────────────────────────────────
    { id: "approvals",     label: "Process Claim",     icon: "✅", group: "merchant" },
    { id: "claimapprovalhistory",     label: "Claim Approval History",     icon: "✅", group: "merchant" },
    { id: "approveredeem", label: "Approve Redemption",    icon: "💜", group: "merchant"  },
    { id: "redeemedapporvalhistory", label: "Approval History",    icon: "💜", group: "merchant"  },
    { id: "certificates",  label: "Merchant QR",      icon: "🪪", group: "merchant" },
    { id: "merchantledger", label: "Merchant Ledger", icon: "📒", group: "merchant" },
    // ── Parents/Mentor tabs ─────────────────────────────────
    { id: "approvals",     label: "Process Claim",     icon: "✅", group: "pm" },
    { id: "claimapprovalhistory",     label: "Claim Approval History",     icon: "✅", group: "pm" },
    { id: "approveredeem", label: "Approve Redemption",    icon: "💜", group: "pm"  },
    { id: "redeemedapporvalhistory", label: "Approval History",    icon: "💜", group: "pm"  },
    // ── Parentstabs ─────────────────────────────────
    { id: "parentledger", label: "Parent Ledger", icon: "📒", group: "parent" },
    // ── Parents/Mentor tabs ─────────────────────────────────
    { id: "mentorledger", label: "Mentor Ledger", icon: "📒", group: "mentor" },
    // -- Flywheel ─────────────────────────────────
    { id: "flywheel",        label: "Flywheel",       icon: "🌀", group: "flywheel" },
    // -- streaksettings ─────────────────────────────────
    { id: "streaksettings",        label: "Streak Settings",       icon: "🌀", group: "streaksettings" },
];

const GROUP_COLORS = {
    user:     { active: "bg-cyan-500 text-black",    dot: "bg-cyan-500"    },
    merchant: { active: "bg-orange-500 text-black",  dot: "bg-orange-500"  },
    leaderboard:   { active: "bg-green-500 text-white",  dot: "bg-green-500"  },
    flywheel:   { active: "bg-green-500 text-white",  dot: "bg-blue-500"  },
};

const getVisibleGroups = (role) => {
        switch ((role || "").toUpperCase()) {
            case "STUDENT":
                return ["user", "leaderboard", "flywheel"];
            case "MERCHANT":
                return ["merchant", "flywheel"];
            case "PARENT":
                return ["pm", "parent", "flywheel", "streaksettings"];
            case "MENTOR":
                return ["pm", "mentor", "flywheel", "streaksettings"];
            case "INFLUENCER":
            case "DIRECTOR":
            case "COORDINATOR":
            case "INSTITUTION":
                return ["leaderboard", "flywheel"];
            default:
                return ["user", "leaderboard", "flywheel"]; // safe fallback
        }
    };


const StreakTabs = ({ selectedTab, setSelectedTab, userRole }) => {
    const pdHomeRef = useRef(null);

    const visibleTabs = TABS.filter(tab =>
        getVisibleGroups(userRole).includes(tab.group)
    );

    return (
        <div className="space-y-2">
            <div className="flex flex-row text-xs justify-center items-center gap-1">
                <div className="w-1.5 h-1.5 rounded-xl text-xs bg-cyan-500" /> User Role: {userRole.toUpperCase()}
                {/* <div className="w-1.5 h-1.5 rounded-xl text-xs bg-orange-500 text-white ml-2" /> Merchant */}
                {/* <div className="w-1.5 h-1.5 rounded-xl text-xs bg-green-500" /> Contest */}
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-5 gap-1">
                {visibleTabs.map((tab) => {
                    const isActive = selectedTab === tab.id;
                    const colors   = GROUP_COLORS[tab.group] || GROUP_COLORS.user;

                    return (
                        <button
                            key={tab.id}
                            onClick={() => !tab.disabled && setSelectedTab(tab.id)}
                            disabled={tab.disabled}
                            whileTap={tab.disabled ? {} : { scale: 0.94 }}
                            className={`px-2 py-1 rounded-lg text-xs lg:text-xs font-bold transition-all overflow-hidden ${
                                tab.disabled
                                    ? "bg-gray-800/40 text-gray-100 border border-gray-800 cursor-not-allowed"
                                    : isActive
                                    ? `${colors.active} shadow-md`
                                    : "bg-gray-800/80 text-gray-100 border border-gray-700/60 hover:border-gray-500"
                            }`}
                        >
                            {isActive && (
                                <div
                                    className={`absolute top-1 right-1 w-1.5 h-1.5 rounded-lg ${colors.dot} opacity-80`}
                                />
                            )}

                            <div className="flex flex-col items-center gap-0.5">
                                <span className="py-0.5 px-1 text-xs lg:text-xs">{tab.icon}{tab.label}</span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export { TABS, getVisibleGroups };
export default StreakTabs;

